export default "__VITE_ASSET__662562af__"